
    import '/home/ec2-user/Youlify-Design/components/button/index.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["button-demo-basic","button-demo-icon","button-demo-icon-position","button-demo-size","button-demo-disabled","button-demo-loading","button-demo-multiple","button-demo-block","button-demo-linear-gradient","button-demo-_semantic"],
  getter: () => import(/* webpackChunkName: "meta__components__en-US" */'/home/ec2-user/Youlify-Design/components/button/index.en-US.md?type=demo')
};